import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { userHasSomeRights } from "../../../functions/userRights";
import i18n from "../../../functions/i18next";

export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      id: this.$options.name,
      role: false,
      menuItems: [
        {
          name: i18n.t("settings_menu.account"),
          icon: "account",
          url: `/${this.$store.state.company}/account`,
          rights: ["edit_branding"],
        },
        {
          name: i18n.t("settings_menu.branding"),
          icon: "branding",
          url: `/${this.$store.state.company}/branding`,
          rights: ["edit_branding"],
        },
        {
          name: i18n.tc("settings_menu.manage_user", 2),
          icon: "users",
          url: `/${this.$store.state.company}/users`,
          rights: ["add_users", "edit_users", "delete_users", "edit_roles"],
        },
        {
          name: i18n.t("common.help_center"),
          icon: "info",
          url: `https://sheprd.zendesk.com/`,
          urlIsExternal: true,
          rights: [],
        },
        {
          name: i18n.t("common.more"),
          icon: "dots--outline",
          extraMenu: [
            {
              name: "Plan & Billing",
              url: `/${this.$store.state.company}/billing`,
              adminOnly: true,
            },
            {
              name: "About us",
              url: `https://sheprd.app`,
              urlIsExternal: true,
            },
            {
              name: "Pricing",
              url: `https://sheprd.app/#pricing`,
              urlIsExternal: true,
            },
            {
              name: "Terms",
              url: `/${this.$store.state.company}/policy`,
            },
          ],
          rights: [],
        },
        {
          name: i18n.t("common.logout"),
          icon: "logout",
          emitterName: `${this.$options.name}-logout`,
          emitterData: {},
          rights: [],
        },
      ],
    };
  },
  beforeMount() {
    this.getRole();
  },
  created() {
    EventBus.$on(`${this.id}-logout`, this.logout);
  },
  methods: {
    getRole() {
      if (this.$store.state.user) {
        //user is present so get roll

        this.$axios
          .get(`${baseUrl}/role?id=${this.$store.state.user.role_id}`)
          .then((response) => {
            this.role = response.data.role;
          });
      }
    },

    checkRights(item) {
      return (
        userHasSomeRights(item.rights, this) && this.checkAdmin(item.adminOnly)
      );
    },
    checkAdmin(adminOnly) {
      return adminOnly
        ? this.$store.state.company_full.isBilling &&
            role.name === "Administrator"
        : true;
    },
    logout() {
      this.$store.state.user = null;
      this.$axios.defaults.params["key"] = null;
      localStorage.setItem(
        this.$store.state.company + "_" + "user",
        JSON.stringify(null)
      );
      localStorage.setItem(
        this.$store.state.company + "_" + "folder_spaces",
        JSON.stringify(null)
      );
      localStorage.setItem(
        this.$store.state.company + "_" + "folder_myspace",
        JSON.stringify(null)
      );
      this.$router.push("/" + this.$store.state.company);
      EventBus.$emit("login"); //Trust me this has te be here ;)
    },
  },
};
